var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 50,
    viewBox: "0 0 82 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.158 49.751L15.04 49.7C16.9327 46.4331 19.652 43.7221 22.9245 41.8392C26.197 39.9564 29.9075 38.9682 33.683 38.974V38.974C37.366 38.98 39.673 34.998 37.838 31.806L31.647 21.042C29.996 18.172 25.858 18.166 24.198 21.03L13.817 38.941L7.59003 49.684C2.07203 49.675 -1.36596 43.7 1.40004 38.922L21.742 3.82199C24.509 -0.952008 31.406 -0.941007 34.157 3.84199L37.872 10.3L54.384 39.008C57.135 43.792 53.676 49.76 48.158 49.751Z",
    fill: "#EA7C69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.965 43.455L55.936 33.013C54.329 30.229 56.336 26.75 59.553 26.75L63.412 33.435C63.6318 33.8158 63.9481 34.1321 64.3289 34.352C64.7097 34.5719 65.1417 34.6877 65.5815 34.6877C66.0212 34.6877 66.4532 34.5719 66.8341 34.352C67.2149 34.1321 67.5311 33.8158 67.751 33.435L71.61 26.75C71.8299 26.3692 71.9458 25.9372 71.9459 25.4974C71.9459 25.0577 71.8303 24.6256 71.6104 24.2448C71.3906 23.8639 71.0744 23.5476 70.6936 23.3277C70.3127 23.1078 69.8807 22.992 69.441 22.992H50.151C48.544 20.209 50.551 16.73 53.767 16.73H77.4C80.614 16.73 82.6229 20.209 81.0159 22.993L78.846 26.75L69.2 43.455C67.59 46.238 63.572 46.238 61.965 43.455Z",
    fill: "#EA7C69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fd34f1a6.svg";
export { ForwardRef as ReactComponent };